import React from 'react';
import { Box, Card, Stack, Typography, alpha } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const formatAmount = (value, fromPaise = false) => {
  if (value == null) return '₹0';
  const amount = fromPaise ? Number(value) / 100 : Number(value);
  if (!Number.isFinite(amount)) return '₹0';
  return `₹${amount.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
};

const CARD_THEMES = {
  Vouchers: {
    accent: '#d97706',
    cardBg:
      'linear-gradient(145deg, #fffbeb 0%, #ffffff 45%, #fff7ed 100%)',
    iconBg: 'linear-gradient(135deg, #fcd34d 0%, #d97706 100%)',
    glow: 'rgba(245, 158, 11, 0.35)',
    chip: 'Rewards',
  },
  Flipkart: {
    accent: '#1d4ed8',
    cardBg:
      'linear-gradient(145deg, #eff6ff 0%, #ffffff 45%, #dbeafe 100%)',
    iconBg: 'linear-gradient(135deg, #60a5fa 0%, #1d4ed8 100%)',
    glow: 'rgba(37, 99, 235, 0.35)',
    chip: 'Balance',
  },
  FlipkartDiscount: {
    accent: '#0891b2',
    cardBg:
      'linear-gradient(145deg, #ecfeff 0%, #ffffff 45%, #cffafe 100%)',
    iconBg: 'linear-gradient(135deg, #22d3ee 0%, #0891b2 100%)',
    glow: 'rgba(8, 145, 178, 0.3)',
    chip: 'Discount',
  },
  Woohoo: {
    accent: '#ea580c',
    cardBg:
      'linear-gradient(145deg, #fff7ed 0%, #ffffff 45%, #ffedd5 100%)',
    iconBg: 'linear-gradient(135deg, #fb923c 0%, #ea580c 100%)',
    glow: 'rgba(234, 88, 12, 0.35)',
    chip: 'Balance',
  },
  Gyftr: {
    accent: '#e11d48',
    cardBg:
      'linear-gradient(145deg, #fff1f2 0%, #ffffff 45%, #ffe4e6 100%)',
    iconBg: 'linear-gradient(135deg, #fb7185 0%, #e11d48 100%)',
    glow: 'rgba(225, 29, 72, 0.35)',
    chip: 'Balance',
  },
  Hubble: {
    accent: '#8b5cf6',
    cardBg:
      'linear-gradient(145deg, #f5f3ff 0%, #ffffff 45%, #ede9fe 100%)',
    iconBg: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
    glow: 'rgba(139, 92, 246, 0.35)',
    chip: 'Balance',
  },
  'Total Users': {
    accent: '#4f46e5',
    cardBg:
      'linear-gradient(145deg, #eef2ff 0%, #ffffff 45%, #e0e7ff 100%)',
    iconBg: 'linear-gradient(135deg, #818cf8 0%, #4f46e5 100%)',
    glow: 'rgba(79, 70, 229, 0.35)',
    chip: 'Users',
  },
  'Active Users': {
    accent: '#059669',
    cardBg:
      'linear-gradient(145deg, #ecfdf5 0%, #ffffff 45%, #d1fae5 100%)',
    iconBg: 'linear-gradient(135deg, #34d399 0%, #059669 100%)',
    glow: 'rgba(5, 150, 105, 0.35)',
    chip: 'Active',
  },
  'Inactive Users': {
    accent: '#475569',
    cardBg:
      'linear-gradient(145deg, #f8fafc 0%, #ffffff 45%, #f1f5f9 100%)',
    iconBg: 'linear-gradient(135deg, #94a3b8 0%, #475569 100%)',
    glow: 'rgba(71, 85, 105, 0.25)',
    chip: 'Inactive',
  },
  'New Users': {
    accent: '#7c3aed',
    cardBg:
      'linear-gradient(145deg, #f5f3ff 0%, #ffffff 45%, #ede9fe 100%)',
    iconBg: 'linear-gradient(135deg, #a78bfa 0%, #7c3aed 100%)',
    glow: 'rgba(124, 58, 237, 0.35)',
    chip: 'Growth',
  },
  'Total Amount': {
    accent: '#0d9488',
    cardBg:
      'linear-gradient(145deg, #f0fdfa 0%, #ffffff 45%, #ccfbf1 100%)',
    iconBg: 'linear-gradient(135deg, #2dd4bf 0%, #0d9488 100%)',
    glow: 'rgba(13, 148, 136, 0.35)',
    chip: 'Revenue',
  },
  'Succes Transactions': {
    accent: '#16a34a',
    cardBg:
      'linear-gradient(145deg, #f0fdf4 0%, #ffffff 45%, #dcfce7 100%)',
    iconBg: 'linear-gradient(135deg, #4ade80 0%, #16a34a 100%)',
    glow: 'rgba(22, 163, 74, 0.35)',
    chip: 'Success',
  },
  'Failed Transactions': {
    accent: '#dc2626',
    cardBg:
      'linear-gradient(145deg, #fef2f2 0%, #ffffff 45%, #fee2e2 100%)',
    iconBg: 'linear-gradient(135deg, #f87171 0%, #dc2626 100%)',
    glow: 'rgba(220, 38, 38, 0.3)',
    chip: 'Failed',
  },
  'Expired Transactions': {
    accent: '#ca8a04',
    cardBg:
      'linear-gradient(145deg, #fffbeb 0%, #ffffff 45%, #fef9c3 100%)',
    iconBg: 'linear-gradient(135deg, #facc15 0%, #ca8a04 100%)',
    glow: 'rgba(202, 138, 4, 0.35)',
    chip: 'Pending',
  },
  Total: {
    accent: '#4f46e5',
    cardBg:
      'linear-gradient(145deg, #eef2ff 0%, #ffffff 45%, #e0e7ff 100%)',
    iconBg: 'linear-gradient(135deg, #818cf8 0%, #4f46e5 100%)',
    glow: 'rgba(79, 70, 229, 0.35)',
    chip: 'All',
  },
  Pending: {
    accent: '#d97706',
    cardBg:
      'linear-gradient(145deg, #fffbeb 0%, #ffffff 45%, #fef3c7 100%)',
    iconBg: 'linear-gradient(135deg, #fbbf24 0%, #d97706 100%)',
    glow: 'rgba(217, 119, 6, 0.35)',
    chip: 'Pending',
  },
  Failed: {
    accent: '#dc2626',
    cardBg:
      'linear-gradient(145deg, #fef2f2 0%, #ffffff 45%, #fee2e2 100%)',
    iconBg: 'linear-gradient(135deg, #f87171 0%, #dc2626 100%)',
    glow: 'rgba(220, 38, 38, 0.3)',
    chip: 'Failed',
  },
  'This week': {
    accent: '#0891b2',
    cardBg:
      'linear-gradient(145deg, #ecfeff 0%, #ffffff 45%, #cffafe 100%)',
    iconBg: 'linear-gradient(135deg, #22d3ee 0%, #0891b2 100%)',
    glow: 'rgba(8, 145, 178, 0.3)',
    chip: 'Weekly',
  },
};

const defaultTheme = {
  accent: '#11409B',
  cardBg: 'linear-gradient(145deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)',
  iconBg: 'linear-gradient(135deg, #11409B 0%, #2563eb 100%)',
  glow: 'rgba(17, 64, 155, 0.3)',
  chip: 'Metric',
};

const getDisplayLabel = (name) => {
  if (name === 'FlipkartDiscount') return 'Flipkart Discount';
  if (name === 'Woohoo') return 'Woohoo Balance';
  if (name === 'Gyftr') return 'Gyftr Balance';
  if (name === 'Hubble') return 'Hubble Balance';
  if (name === 'Succes Transactions') return 'Success Transactions';
  return name;
};

export const MasterCard = ({
  src,
  alt,
  name,
  users,
  vouchers,
  totalUsers,
  usersresults,
  flipkartAmount,
  flipkartDiscount,
  woohooBalance,
  gyftrBalance,
  hubbleBalance,
  activeUsers,
  inactiveUsers,
  newUsers,
  successTransactions,
  failedTransactions,
  pendingTransactions,
  totalAmount,
  count,
  amountFromPaise = true,
}) => {
  const theme = CARD_THEMES[name] || defaultTheme;

  const totalUsersCount = Array.isArray(users)
    ? users.length
    : Number(totalUsers) || 0;
  const activeUsersCount = Number(activeUsers) || 0;
  const inactiveUsersCount = Number(inactiveUsers) || 0;
  const newUsersCount = Number(newUsers) || 0;

  const displayValue = (() => {
    if (name === 'Users') return usersresults ?? '—';
    if (name === 'Total Users') return totalUsersCount;
    if (name === 'New Users') return newUsersCount;
    if (name === 'Vouchers') return vouchers ?? 0;
    if (name === 'Total Amount') return formatAmount(totalAmount, amountFromPaise);
    if (name === 'Succes Transactions') return Number(successTransactions) || 0;
    if (name === 'Failed Transactions') return Number(failedTransactions) || 0;
    if (name === 'Pending Transactions') return Number(pendingTransactions) || 0;
    if (name === 'Flipkart') return formatAmount(flipkartAmount, false);
    if (name === 'FlipkartDiscount') return `${flipkartDiscount ?? 0}%`;
    if (name === 'Woohoo') return formatAmount(woohooBalance, false);
    if (name === 'Gyftr') return formatAmount(gyftrBalance, false);
    if (name === 'Hubble') return formatAmount(hubbleBalance, false);
    if (name === 'Active Users') return activeUsersCount;
    if (name === 'Inactive Users') return inactiveUsersCount;
    return count ?? '—';
  })();

  const showTrend =
    name === 'Succes Transactions' ||
    name === 'New Users' ||
    name === 'Total Amount';

  return (
    <Card
      elevation={0}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 148,
        borderRadius: '22px',
        background: theme.cardBg,
        border: '1px solid',
        borderColor: alpha(theme.accent, 0.14),
        boxShadow: `
          0 1px 2px ${alpha('#0f172a', 0.04)},
          0 8px 32px ${alpha(theme.accent, 0.1)},
          inset 0 1px 0 ${alpha('#fff', 0.9)}
        `,
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.3s ease',
        cursor: 'default',
        '&:hover': {
          transform: 'translateY(-6px) scale(1.01)',
          boxShadow: `
            0 4px 8px ${alpha('#0f172a', 0.06)},
            0 20px 48px ${alpha(theme.accent, 0.22)},
            inset 0 1px 0 ${alpha('#fff', 1)}
          `,
          '& .metric-glow': { opacity: 0.55, transform: 'scale(1.15)' },
          '& .icon-ring': { transform: 'scale(1.05)' },
        },
      }}
    >
      {/* Decorative glow orb */}
      <Box
        className="metric-glow"
        sx={{
          position: 'absolute',
          top: -40,
          right: -40,
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.glow} 0%, transparent 70%)`,
          opacity: 0.35,
          transition: 'opacity 0.3s, transform 0.3s',
          pointerEvents: 'none',
        }}
      />

      {/* Accent strip */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          background: theme.iconBg,
        }}
      />

      <Box
        sx={{
          p: 2.5,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
          mb={2}
        >
          <Box
            className="icon-ring"
            sx={{
              position: 'relative',
              transition: 'transform 0.3s ease',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                inset: -4,
                borderRadius: '18px',
                border: `2px solid ${alpha(theme.accent, 0.15)}`,
              }}
            />
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: '16px',
                background: theme.iconBg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0 10px 28px ${alpha(theme.accent, 0.4)}`,
              }}
            >
              <Box
                component="img"
                src={src}
                alt={alt}
                sx={{
                  width: 28,
                  height: 28,
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)',
                }}
              />
            </Box>
          </Box>

          <Stack alignItems="flex-end" spacing={0.75}>
            <Box
              sx={{
                px: 1.25,
                py: 0.35,
                borderRadius: '8px',
                fontSize: '0.65rem',
                fontWeight: 700,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: theme.accent,
                bgcolor: alpha(theme.accent, 0.1),
                border: `1px solid ${alpha(theme.accent, 0.15)}`,
              }}
            >
              {theme.chip}
            </Box>
            {showTrend && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 28,
                  height: 28,
                  borderRadius: '10px',
                  bgcolor: alpha('#16a34a', 0.12),
                  border: `1px solid ${alpha('#16a34a', 0.2)}`,
                }}
              >
                <TrendingUpIcon sx={{ fontSize: 16, color: '#16a34a' }} />
              </Box>
            )}
          </Stack>
        </Stack>

        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              color: '#64748b',
              fontWeight: 600,
              fontSize: '0.75rem',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              mb: 0.75,
              lineHeight: 1.3,
            }}
          >
            {getDisplayLabel(name)}
          </Typography>
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: { xs: '1.5rem', sm: '1.75rem' },
              background: `linear-gradient(135deg, #0f172a 30%, ${theme.accent} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.03em',
              lineHeight: 1.1,
            }}
          >
            {displayValue}
          </Typography>
        </Box>

        <Stack
          direction="row"
          alignItems="center"
          spacing={0.75}
          sx={{
            mt: 2,
            pt: 1.5,
            borderTop: `1px solid ${alpha(theme.accent, 0.1)}`,
          }}
        >
          <FiberManualRecordIcon
            sx={{ fontSize: 8, color: '#22c55e', filter: 'drop-shadow(0 0 4px #22c55e)' }}
          />
          <Typography
            variant="caption"
            sx={{ color: '#94a3b8', fontWeight: 500, fontSize: '0.7rem' }}
          >
            Live from dashboard
          </Typography>
        </Stack>
      </Box>
    </Card>
  );
};
